import React from 'react';
import { Grid, Typography } from '@material-ui/core';

const MembershipBenefits = ({ benefits = [] }) => {
  return (
    <Grid container spacing={1}>
      {benefits.map((text, index) => (
        <Grid item key={index}>
          <Typography color="textSecondary">
            {text}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
};

export default MembershipBenefits;
